import { Component, OnInit } from '@angular/core';
import { AppAuthService } from '../../core/auth/app-auth.service';

@Component({
    selector: 'sca-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class AppLoginComponent implements OnInit {
  public isAuthenticating: boolean = false;

  constructor(
    private _authService: AppAuthService
  ) { }

  ngOnInit(): void {
    this.onLoginClick();
  }

  public onLoginClick(): void {
    // auth flow already started by the guard

    this.isAuthenticating = true;

    // expecting the login to redirect to the auth-callback component
    this._authService.login();
  }
}
